// src/components/PublisherIDCard.jsx
// Phase P1.5: Publisher ID Card Component - Identity info only (logo moved to header)
import React from 'react';
import { Link } from 'react-router-dom';
import { User, Mail, Hash, Edit } from 'lucide-react';

const PublisherIDCard = ({ profile, loading, compact = false }) => {
  if (loading) {
    return (
      <div className={`rounded-2xl border border-slate-700 bg-slate-900/80 ${compact ? 'p-4 min-w-[240px]' : 'p-5 min-w-[280px]'} animate-pulse`}>
        <div className="space-y-2">
          <div className="h-5 bg-slate-700 rounded w-3/4"></div>
          <div className="h-4 bg-slate-700 rounded w-1/2"></div>
          <div className="h-4 bg-slate-700 rounded w-2/3"></div>
        </div>
      </div>
    );
  }

  return (
    <div className={`rounded-2xl border border-slate-700 bg-slate-900/80 backdrop-blur ${compact ? 'p-4 w-full max-w-[280px]' : 'p-6 w-full max-w-sm lg:max-w-md'}`}>
      {/* DBA Name & Business Name */}
      <div className={compact ? 'mb-3' : 'mb-4'}>
        <h3 className={`font-semibold text-white ${compact ? 'text-base' : 'text-xl'}`}>
          {profile?.dba_name || profile?.legal_business_name || 'Publisher'}
        </h3>
        {profile?.dba_name && profile?.legal_business_name && (
          <p className={`text-slate-400 ${compact ? 'text-xs' : 'text-sm'}`}>
            {profile.legal_business_name}
          </p>
        )}
      </div>

      {/* Contact & EIN Info */}
      <div className={`space-y-1.5 ${compact ? 'text-xs' : 'text-sm'}`}>
        {profile?.primary_contact_name && (
          <div className="flex items-center gap-2 text-slate-300">
            <User className={`${compact ? 'w-3 h-3' : 'w-4 h-4'} text-slate-500 flex-shrink-0`} />
            <span className="truncate">{profile.primary_contact_name}</span>
          </div>
        )}
        {profile?.primary_contact_email && (
          <div className="flex items-center gap-2 text-slate-400">
            <Mail className={`${compact ? 'w-3 h-3' : 'w-4 h-4'} text-slate-500 flex-shrink-0`} />
            <span className="truncate">{profile.primary_contact_email}</span>
          </div>
        )}
        {profile?.ein && (
          <div className="flex items-center gap-2 text-slate-400">
            <Hash className={`${compact ? 'w-3 h-3' : 'w-4 h-4'} text-slate-500 flex-shrink-0`} />
            <span className="font-mono">EIN: {profile.ein}</span>
          </div>
        )}
      </div>

      {/* Edit Link */}
      <Link
        to="/publisher/profile"
        className={`${compact ? 'mt-3 py-1.5 text-xs' : 'mt-5 py-2.5 text-sm'} flex items-center justify-center gap-2 w-full rounded-lg bg-slate-800 hover:bg-slate-700 px-3 font-medium text-slate-300 transition-colors`}
      >
        <Edit className={`${compact ? 'w-3 h-3' : 'w-4 h-4'}`} />
        Edit Profile
      </Link>
    </div>
  );
};

export default PublisherIDCard;
